import { Button, ButtonSizes, ButtonStyles, Dropdown, ListItemProps, TextInput } from '@silverfort/sf-components';
import { useRef, useState } from 'react';

export const EQUATION_TYPES_DEFAULTS: ListItemProps<unknown>[] = [
    {
        title: 'Starts with',
        value: 1
    },
    {
        title: 'Contains',
        value: 2
    },
    {
        title: 'Ends with',
        value: 3
    }
];

interface EquationPopUpProps {
    handleApply: (conditionString: string, conditionType: number) => void;
    handleClose: () => void;
    defaultValue: { conditionString: string; conditionType: number } | undefined;
}

const EquationPopUp = ({ handleApply, handleClose, defaultValue }: EquationPopUpProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const [conditionType, setConditionType] = useState(defaultValue?.conditionType || 1);
    const [conditionString, setConditionString] = useState(defaultValue?.conditionString || '');
    return (
        <div className="w-[264px] font-sf bg-white z-10 absolute mt-2  rounded-lg  p-2 shadow-sf-medium right-8">
            <div className="flex h-14 gap-2 p-2">
                <Dropdown
                    selectedItems={conditionType}
                    variant="trigger"
                    items={EQUATION_TYPES_DEFAULTS}
                    onChange={(type) => setConditionType(type as number)}
                />
                <TextInput
                    ref={inputRef}
                    numbersOnly={false}
                    autoFocus={true}
                    placeholder="Value"
                    className="w-[80px]"
                    value={conditionString}
                    onChange={(value) => setConditionString(value)}
                />
            </div>
            <div className="flex h-12 items-center justify-end gap-2 self-stretch border-0 border-t border-solid border-sf-gray-100 px-4">
                <Button
                    buttonSize={ButtonSizes.Small}
                    buttonStyle={ButtonStyles.TertiarySolid}
                    text="Cancel"
                    onClick={handleClose}
                />
                <Button
                    buttonSize={ButtonSizes.Small}
                    text="Apply"
                    disabled={conditionString === ''}
                    onClick={() => {
                        handleApply(conditionString, conditionType);
                    }}
                />
            </div>
        </div>
    );
};
export default EquationPopUp;
